const FINANCIAL_STATEMENT_CHUNK_TITLES = new Set([
  "재무상태표",
  "손익계산서",
  "포괄손익계산서",
  "현금흐름표",
  "자본변동표",
]);

export const isFinancialStatementChunkTitle = (title: string): boolean =>
  FINANCIAL_STATEMENT_CHUNK_TITLES.has(title.trim());
